import { Skeleton } from "@/components/ui/skeleton";

const CategorySkeleton = () => (
  <div className="flex items-center gap-3 rounded-lg border border-border bg-card px-4 py-3">
    <Skeleton className="h-10 w-10 rounded-full" />
    <div className="flex-1 space-y-1.5">
      <Skeleton className="h-4 w-28" />
      <Skeleton className="h-3 w-20" />
    </div>
    <Skeleton className="h-5 w-8 rounded-full" />
  </div>
);

const DisclosureRowSkeleton = () => (
  <div className="flex items-center gap-3 rounded-lg border border-border bg-card px-4 py-3">
    <Skeleton className="h-10 w-10 rounded-lg" />
    <div className="flex-1 space-y-1.5">
      <div className="flex items-center gap-2">
        <Skeleton className="h-4 w-14 rounded" />
        <Skeleton className="h-4 w-40" />
      </div>
      <div className="flex items-center gap-3">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-3 w-10" />
        <Skeleton className="h-3 w-24" />
      </div>
    </div>
    <Skeleton className="h-8 w-28 rounded" />
  </div>
);

const DisclosureListSkeleton = () => (
  <div className="space-y-4">
    <div className="space-y-3">
      <CategorySkeleton />
      <div className="space-y-3 pl-2">
        <DisclosureRowSkeleton />
        <DisclosureRowSkeleton />
        <DisclosureRowSkeleton />
      </div>
    </div>
    <CategorySkeleton />
    <CategorySkeleton />
  </div>
);

export default DisclosureListSkeleton;
